import { render, staticRenderFns } from "./studytrain.vue?vue&type=template&id=27d3975e&scoped=true&"
import script from "./studytrain.vue?vue&type=script&lang=js&"
export * from "./studytrain.vue?vue&type=script&lang=js&"
import style0 from "./studytrain.vue?vue&type=style&index=0&id=27d3975e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d3975e",
  null
  
)

export default component.exports